<template>

<transition name="root-transitions" :enter-active-class="enterActive" :leave-active-class="leaveActive">
  <slot></slot>
</transition>
</template>

<script>
  const not = [
    'Request Password Reset',
    'Reset'
  ]
  export default {
    name: 'c-s-s-root-transitions',
    data () {
      return {
        to: null,
        from: null
      }
    },
    computed: {
      enterActive () {
        let value = ''
        if (this.to && this.from && this.to.hasOwnProperty('name') && this.from.hasOwnProperty('name')) {
          if (this.to.name === 'Login' && !not.includes(this.from.name)) {
            value = 'root-transition-lock-enter-active'
          } else if (!not.includes(this.to.name) && this.from.name === 'Login') {
            value = 'root-transition-dashboard-enter-active'
          }
        }
        return value
      },
      leaveActive () {
        let value = ''
        if (this.to && this.from && this.to.hasOwnProperty('name') && this.from.hasOwnProperty('name')) {
          if (this.to.name === 'Login' && !not.includes(this.from.name)) {
            value = 'root-transition-dashboard-leave-active'
          } else if (!not.includes(this.to.name) && this.from.name === 'Login') {
            value = 'root-transition-lock-leave-active'
          }
        }
        return value
      }
    },
    watch: {
      '$route' (to, from) {
        this.to = to
        this.from = from
      }
    }
  }
</script>

<style>

/*.root-transition-lock-out*/
/*position absolute*/
/*left 0*/
/*right 0*/
/*z-index 1*/.root-transition-lock-enter-active {
  animation: root-trans-slide-in 1s;
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
}.root-transition-lock-leave-active {
  animation: root-trans-slide-out 1s;
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
}.root-transition-dashboard-enter-active {
  animation: root-trans-scale-up 1s;
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}.root-transition-dashboard-leave-active {
  animation: root-trans-scale-up 1s reverse;
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}


@-webkit-keyframes root-trans-scale-up {
  0% {
    transform: scale(0.8);
  }100% {
    transform: scale(1);
  }
}


@-moz-keyframes root-trans-scale-up {
  0% {
    transform: scale(0.8);
  }100% {
    transform: scale(1);
  }
}


@-ms-keyframes root-trans-scale-up {
  0% {
    transform: scale(0.8);
  }100% {
    transform: scale(1);
  }
}


@-o-keyframes root-trans-scale-up {
  0% {
    transform: scale(0.8);
  }100% {
    transform: scale(1);
  }
}


@keyframes root-trans-scale-up {
  0% {
    transform: scale(0.8);
  }100% {
    transform: scale(1);
  }
}


@-webkit-keyframes root-trans-slide-in {
  0% {

    top: -100%;
  }100% {

    top: 0;
  }
}


@-moz-keyframes root-trans-slide-in {
  0% {

    top: -100%;
  }100% {

    top: 0;
  }
}


@-ms-keyframes root-trans-slide-in {
  0% {

    top: -100%;
  }100% {

    top: 0;
  }
}


@-o-keyframes root-trans-slide-in {
  0% {

    top: -100%;
  }100% {

    top: 0;
  }
}


@keyframes root-trans-slide-in {
  0% {

    top: -100%;
  }100% {

    top: 0;
  }
}

@-webkit-keyframes root-trans-slide-out {
  0% {
    transform: translateY(0%);
  }100% {
    transform: translateY(-100%);
  }
}

@-moz-keyframes root-trans-slide-out {
  0% {
    transform: translateY(0%);
  }100% {
    transform: translateY(-100%);
  }
}

@-ms-keyframes root-trans-slide-out {
  0% {
    transform: translateY(0%);
  }100% {
    transform: translateY(-100%);
  }
}

@-o-keyframes root-trans-slide-out {
  0% {
    transform: translateY(0%);
  }100% {
    transform: translateY(-100%);
  }
}

@keyframes root-trans-slide-out {
  0% {
    transform: translateY(0%);
  }100% {
    transform: translateY(-100%);
  }
}
</style>
